// APIs of the thervumitra-commerce plugin: shop (LMS) and admin (Studio).
import { getConfig } from '@edx/frontend-platform';
import { getAuthenticatedHttpClient } from '@edx/frontend-platform/auth';

const lms = () => `${getConfig().LMS_BASE_URL}/api/thervumitra/commerce/v1`;
const studio = () => `${getConfig().STUDIO_BASE_URL}/api/thervumitra/commerce/v1/manage`;
const http = () => getAuthenticatedHttpClient();

async function call(promise) {
  try {
    const { data } = await promise;
    return data;
  } catch (err) {
    let body = null;
    try {
      const raw = err?.customAttributes?.httpErrorResponseData;
      body = raw ? JSON.parse(raw) : err?.response?.data;
    } catch (e) { body = null; }
    throw Object.assign(new Error('failed'), {
      status: err?.customAttributes?.httpErrorStatus || err?.response?.status || 0,
      code: body?.error || null, errors: body?.errors || null,
    });
  }
}

// Tells every cart badge on the page to refresh.
export const cartChanged = () => window.dispatchEvent(new Event('bm-cart-changed'));

export const getPrices = ({ courses = [] }) => call(http().get(`${lms()}/prices/`, {
  params: { courses: courses.join(',') },
}));
export const getCart = (coupon, state) => call(http().get(`${lms()}/cart/`, { params: { coupon, state } }));
export async function addToCart(kind, ref, fromWishlist) {
  const data = await call(http().post(`${lms()}/cart/`, { kind, ref, from_wishlist: !!fromWishlist }));
  cartChanged();
  return data;
}
export async function removeFromCart(kind, ref) {
  const data = await call(http().delete(`${lms()}/cart/`, { params: { kind, ref } }));
  cartChanged();
  return data;
}
export const getWishlist = () => call(http().get(`${lms()}/wishlist/`));
export const addToWishlist = (kind, ref) => call(http().post(`${lms()}/wishlist/`, { kind, ref }));
export const removeFromWishlist = (kind, ref) => call(http().delete(`${lms()}/wishlist/`, { params: { kind, ref } }));
export const checkout = (coupon, billing) => call(http().post(`${lms()}/checkout/`, { coupon, billing }));
export const verifyPayment = (number, payment) => call(http().post(`${lms()}/orders/${number}/verify/`, payment));
export const cancelOrder = number => call(http().post(`${lms()}/orders/${number}/cancel/`, {}));
export const listOrders = () => call(http().get(`${lms()}/orders/`));
export const getOrder = number => call(http().get(`${lms()}/orders/${number}/`));

export const adminPrices = (q, kind) => call(http().get(`${studio()}/prices/`, { params: { q, kind } }));
export const adminSetPrice = body => call(http().put(`${studio()}/prices/`, body));
export const adminPlans = () => call(http().get(`${studio()}/plans/`));
export const adminCreatePlan = body => call(http().post(`${studio()}/plans/`, body));
export const adminSavePlan = (ref, body) => call(http().put(`${studio()}/plans/${encodeURIComponent(ref)}/`, body));
export const adminDeletePlan = ref => call(http().delete(`${studio()}/plans/${encodeURIComponent(ref)}/`));
export const adminList = what => call(http().get(`${studio()}/${what}/`));
export const adminCreate = (what, body) => call(http().post(`${studio()}/${what}/`, body));
export const adminUpdate = (what, id, body) => call(http().put(`${studio()}/${what}/${id}/`, body));
export const adminDelete = (what, id) => call(http().delete(`${studio()}/${what}/${id}/`));
export const adminOrders = (status, q) => call(http().get(`${studio()}/orders/`, { params: { status, q } }));
export const adminRefund = (number, reason) => call(http().post(`${studio()}/orders/${number}/refund/`, { reason }));
export const adminSummary = () => call(http().get(`${studio()}/summary/`));
